/**
 * Havas Creative — JavaScript Entry Point
 *
 * Creative-specific JS. The shared parent (main.js) is loaded separately.
 */

import initGradientBlob from '../../../../havas-global-v2/front/src/scripts/blocks/gradient-blob.js';

document.addEventListener('DOMContentLoaded', function () {
    // Creative-specific blocks
    initGradientBlob({
        blockSelector: '.creative-block-bg--gradient',
        blobSelector: '.creative-gradient-blob--block',
        staticClass: 'creative-gradient-blob--static',
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const mediaQuery = window.matchMedia('(min-width: 841px)');

    const hero = document.querySelector('.f-herohome-creative');
    const media = hero?.querySelector('video');

    if (!hero || !media) return;

    let currentScale = 0.6;
    let targetScale = 0.6;
    let ticking = false;
    let isEnabled = false;

    const animate = () => {
        currentScale += (targetScale - currentScale) * 0.08;

        media.style.transform = `scale(${currentScale})`;

        if (Math.abs(targetScale - currentScale) > 0.001) {
            requestAnimationFrame(animate);
        } else {
            ticking = false;
        }
    };

    const update = () => {
        if (!isEnabled) return;

        const progress = Math.min(
            window.scrollY / hero.offsetHeight,
            1
        );

        targetScale = 0.6 + progress * 0.2;

        if (!ticking) {
            ticking = true;
            requestAnimationFrame(animate);
        }
    };

    const handleBreakpoint = (e) => {
        isEnabled = e.matches;

        if (!isEnabled) {
            media.style.transform = '';
            currentScale = 1;
            targetScale = 1;
            window.removeEventListener('scroll', update);
            return;
        }

        currentScale = 0.6;
        targetScale = 0.6;

        update();
        window.addEventListener('scroll', update, { passive: true });
    };

    handleBreakpoint(mediaQuery);
    mediaQuery.addEventListener('change', handleBreakpoint);
});
